import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfileScheduleParams } from '@/shared/api/requests/club/club-schedule/post/request';
import { postClubProfileSchedule } from '@/shared/api/requests/club/club-schedule/post/request';

export const useClubProfileScheduleMutation = (
  settings?: MutationSettings<
    PostClubProfileScheduleParams,
    typeof postClubProfileSchedule
  >
) =>
  useMutation({
    mutationKey: ['ClubProfileSchedule'],
    mutationFn: ({ params, config }) =>
      postClubProfileSchedule({
        params,
        config
      }),
    ...settings?.options
  });
